module.exports = __webpack_public_path__ + "static/apteekkariliitto-fe5a350c8f88f171ffb1d108c6c4ec39.svg";